<template>
  <Loading :data="[bcd]">
    <h2>Policies</h2>
    <FWMLv2PolicyViz :policies="policies"/>
    <h2>NATVS-Policies</h2>
    <FWMLv2PolicyViz :policies="natvs_policies"/>
    <!-- <h2>Coreconf-ACLs</h2>
    <FWMLv2PolicyViz :policies="coreconf_acls"/> -->
  </Loading>
</template>

<script>
import RangeService from '@/api-services/dns_bcd.service'
import Loading from '@/components/Loading.vue'
import FWMLv2PolicyViz from '@/components/fwml/FWMLv2PolicyViz.vue'

export default {
  name: 'BCDRights',
  components: { FWMLv2PolicyViz, Loading },
  data() {
    return {
      bcd: null,
      policies: null,
      natvs_policies: null,
      coreconf_acls: null,
    }
  },
  props: {
    bcd_name: {
      type: String,
      required: true
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loaded = null
      const fwResponse = await RangeService.getPolicies(this.$store.state, this.bcd_name)
      console.debug('FW Response: ', fwResponse)
      this.policies = fwResponse.data.bcd_info[0].value
      this.natvs_policies = fwResponse.data.bcd_info[1].value
      if (typeof this.natvs_policies === 'string') {
        this.natvs_policies = JSON.parse(this.natvs_policies)
      }
      this.coreconf_acls = fwResponse.data.bcd_info[2].value
      this.bcd = fwResponse.data.bcd_list[0]
      this.loaded = true
      this.$store.commit('setNavigationRefreshHandle', { gpk: this.bcd.gpk, objType: 'nd.bcd' })
    },
  }
}
</script>
